import { render, staticRenderFns } from "./ResolutionSelector.vue?vue&type=template&id=5564b0ad&scoped=true"
import script from "./ResolutionSelector.vue?vue&type=script&lang=js"
export * from "./ResolutionSelector.vue?vue&type=script&lang=js"
import style0 from "./ResolutionSelector.vue?vue&type=style&index=0&id=5564b0ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-load_f5b883aeb3d125b1f29ae1b8ca7c56aa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5564b0ad",
  null
  
)

export default component.exports